import { SchedulesSearchFormDataType } from "../../../../models/list/search"

export const checkEmptySearchCondition = (
  values: SchedulesSearchFormDataType,
) =>
  !Object.entries(values).some(([key, value]) =>
    key === "transitSearchType" ? value !== "0" : !!value,
  )
